import { Trans } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";
import {
	type PendingSavedPermit,
	stashPendingSavedPermit,
} from "@offstreetparking/portal-flow/components/CreatePermitWizard/hooks/useSavedPermits";
import { PaymentErrorAlert } from "@offstreetparking/portal-flow/components/forms/Alert";
import type { RouterOutputs } from "~/services/offstreetApi/types";

type TouchNetFormProps = {
	paymentSession: NonNullable<RouterOutputs["paymentSession"]["createPaymentSessionPublic"]["session"]>;
	formId: string;
	setIsProcessing: (isProcessing: boolean) => void;
	pendingSavedPermit?: PendingSavedPermit;
};

export const TouchNetForm = ({ paymentSession, formId, setIsProcessing, pendingSavedPermit }: TouchNetFormProps) => {
	const touchNet = paymentSession.client?.touchnet;

	if (!paymentSession.clientSecret || !touchNet) {
		return <PaymentErrorAlert />;
	}

	return (
		<form
			id={formId}
			method="POST"
			action={touchNet.upaySiteUrl}
			className="space-y-4"
			onSubmit={() => {
				if (pendingSavedPermit) {
					stashPendingSavedPermit(pendingSavedPermit);
				}
				setIsProcessing(true);
			}}
		>
			<input type="hidden" name="TICKET" value={paymentSession.clientSecret} />
			<input type="hidden" name="TICKET_NAME" value={paymentSession.paymentId} />
			<input type="hidden" name="UPAY_SITE_ID" value={touchNet.upaySiteId} />
			<Text>
				<Trans>You’ll continue to your institution’s secure payment page to complete your payment.</Trans>
			</Text>
		</form>
	);
};
